let timer: number;

export const debounce = (fn: () => void, delay: number) => {
  window.clearTimeout(timer);
  timer = window.setTimeout(() => fn(), delay);
};
